/* Frankie & Belle, Buy now. Zie snippets/buy-buttons.liquid voor het waarom.

   Zet de gekozen variant in de wagen via /cart/add.js en gaat dan naar /checkout. Wat er al in
   de wagen zat gaat mee, net als bij een gewone bestelling; dat houdt de staffel intact.

   Luistert op document en niet op de knop zelf: Dawn tekent het hele knoppenblok opnieuw bij
   elke kleur- of maatwissel, en dan is een listener op de oude knop weg. Het formulier wordt
   pas bij de klik opgezocht, via data-form, om dezelfde reden.

   FormData(form) neemt ook het aantal mee, want Dawn's aantalveld hangt met form="..." aan
   het productformulier en staat er buiten.
*/
(() => {
  if (window.fbBuyNow) return;
  window.fbBuyNow = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function toonFout(form, tekst) {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const plek = wrapper?.querySelector('.product-form__error-message');
    if (!wrapper || !plek) return;
    plek.textContent = tekst;
    wrapper.hidden = false;
  }

  document.addEventListener('click', async (e) => {
    const knop = e.target.closest('[data-fb-buynow]');
    if (!knop || knop.disabled || knop.getAttribute('aria-busy') === 'true') return;

    const form = document.getElementById(knop.dataset.form);
    if (!form) return;

    const tekst = knop.querySelector('span');
    const oud = tekst ? tekst.textContent : '';
    knop.setAttribute('aria-busy', 'true');
    if (tekst) tekst.textContent = 'One moment';

    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw data;
      window.location.href = root + 'checkout';
    } catch (err) {
      toonFout(form, (err && (err.description || err.message)) || 'That did not work. Please try again.');
      knop.removeAttribute('aria-busy');
      if (tekst) tekst.textContent = oud;
    }
  });
})();
